import React from 'react';
import { Carousel, Divider, Col, Row } from 'antd';

import './styles.css';
import home1 from './img/home-1.jpeg';
import home2 from './img/home-2.jpeg';
import home3 from './img/home-3.jpeg';
import home4 from './img/home-4.jpeg';

import productChiller from './img/product-chiller.jpeg'
import productCrac1 from './img/product-crac-1.jpeg'
import productCrac2 from './img/product-crac-2.jpeg'
import productCrac3 from './img/product-crac-3.jpeg'
import productLcc from './img/product-lcc.jpeg'
import productOutdoorUnit from './img/product-outdoor-unit.jpeg'

import user1 from './img/user-1.jpeg'
import user2 from './img/user-2.jpeg'
import user3 from './img/user-3.jpeg'
import user4 from './img/user-4.jpeg'
import user5 from './img/user-5.jpeg'
import user6 from './img/user-6.jpeg'
import user7 from './img/user-7.jpeg'
import user8 from './img/user-8.jpeg'


const HomePage = () => {
  return (
    <div>
      <Carousel autoplay>
        <div>
          <img src={home1} alt="Home Page 1" />
        </div>
        <div>
          <img src={home2} alt="Home Page 2" />
        </div>
        <div>
          <img src={home3} alt="Home Page 3" />
        </div>
        <div>
          <img src={home4} alt="Home Page 4" />
        </div>
      </Carousel>

      <div className='body-div'>
        <div className='section-div about-div'>
          <div className='section-header'>
            <div className='section-header-title'>
              关于我们
            </div>
            <Divider plain>About Us</Divider>
          </div>
          <div className='about-body'>
            艾美康是一家专业提供MR医疗设备专用冷水机、机房空调的设备供应商。推出MR废热采暖／卫生热水绿色环保、废热回收冷水机；成功研发加速器、PET CT差异性换气恒温恒湿机房空调、LCC等产品。艾美康致力于为客户提供个性化定制服务，满足客户特殊的制冷需求。
          </div>
        </div>

        <div className='section-div'>
          <div className='section-header'>
            <div className='section-header-title'>
              产品展示
            </div>
            <Divider plain>Products and Applications</Divider>
            <div className='section-header-text'>
              让用户轻松选择冷水机
            </div>
          </div>

          <Row>
            <Col span={8}>
              <div className='card-div'>
                <img src={productChiller} alt="chiller unit" />
                <div className='card-body'>
                  冷水机
                </div>
              </div>
            </Col>
            <Col span={8}>
              <div className='card-div'>
                <img src={productCrac1} alt="CRAC unit" />
                <div className='card-body'>
                  机房专用空调
                </div>
              </div>
            </Col>
            <Col span={8}>
              <div className='card-div'>
                <img src={productCrac2} alt="CRAC unit" />
                <div className='card-body'>
                  小型机房空调
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col span={8}>
              <div className='card-div'>
                <img src={productCrac3} alt="CRAC unit" />
                <div className='card-body'>
                  SPECIAL换气空调
                </div>
              </div>
            </Col>
            <Col span={8}>
              <div className='card-div'>
                <img src={productLcc} alt="LCC unit" />
                <div className='card-body'>
                  LCC
                </div>
              </div>
            </Col>
            <Col span={8}>
              <div className='card-div'>
                <img src={productOutdoorUnit} alt="outdoor unit" />
                <div className='card-body'>
                  室外机
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div className='section-div'>
          <div className='section-header'>
            <div className='section-header-title'>
              典型用户
            </div>
            <Divider plain>Typical Users</Divider>
          </div>

          <Row>
            <Col span={6}>
              <div className='card-div'>
                <img src={user1} alt="User" />
              </div>
            </Col>
            <Col span={6}>
              <div className='card-div'>
                <img src={user2} alt="User" />
              </div>
            </Col>
            <Col span={6}>
              <div className='card-div'>
                <img src={user3} alt="User" />
              </div>
            </Col>
            <Col span={6}>
              <div className='card-div'>
                <img src={user4} alt="User" />
              </div>
            </Col>
          </Row>

          <Row>
            <Col span={6}>
              <div className='card-div'>
                <img src={user5} alt="User" />
              </div>
            </Col>
            <Col span={6}>
              <div className='card-div'>
                <img src={user6} alt="User" />
              </div>
            </Col>
            <Col span={6}>
              <div className='card-div'>
                <img src={user7} alt="User" />
              </div>
            </Col>
            <Col span={6}>
              <div className='card-div'>
                <img src={user8} alt="User" />
              </div>
            </Col>
          </Row>
        </div>

        <div className='section-div contact-div'>
          <div className='section-header'>
            <div className='section-header-title'>
              联系我们
            </div>
            <Divider plain>Contact Us</Divider>
          </div>

          <div className='contact-body'>
            <div>
              地址：北京市朝阳区望京广顺南大街19号嘉润花园B座2801室
            </div>
            <div>
              邮编：100102
            </div>
            <div>
              电话：010-64775056／64775058  /  64775068
            </div>
            <div>
              售后服务热线：400-817-8884
            </div>
            <div>
              邮箱：bhy2801@126.com
            </div>
          </div>
        </div>
      </div>
    </div>
    
  );
};
export default HomePage;